import { ContentTypography } from "../ServiceModal.styles";

export default function UnsuccessfulCopyingSharingLink() {
    const modalContent = (
        <ContentTypography>
            Fehler beim Kopieren in die Zwischenablage. Bitte aktualisieren Sie
            die Seite und versuchen Sie es erneut
        </ContentTypography>
    );
    return { modalContent, autoClosingModal: true };
}
